import { render, staticRenderFns } from "./ivst.vue?vue&type=template&id=caf48b02&scoped=true"
import script from "./ivst.vue?vue&type=script&lang=js"
export * from "./ivst.vue?vue&type=script&lang=js"
import style0 from "./ivst.vue?vue&type=style&index=0&id=caf48b02&prod&scoped=true&lang=css"
import style1 from "./ivst.vue?vue&type=style&index=1&id=caf48b02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caf48b02",
  null
  
)

export default component.exports